module.exports = __webpack_public_path__ + "img/logo.0838a514.png";